define("shared/components/shared/post/secondary/publishing-method-setup/no-publish-method/index", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Post::Secondary::PublishingMethodSetup::Layout @title={{t "onboarding.side_wiz.general.title"}}>
    <:body>
      <p>{{this.profileDescription}}</p>
      {{#if @isMultiProfilePost}}
        <div class="u--m__tb">
          <Shared::Ui::Button @onClick={{@back}} @variant="actionLink">
            {{svg-jar "arrow-left" class="o--icon u--m__r__xs"}}
            {{t "shared_words.back"}}
          </Shared::Ui::Button>
        </div>
      {{/if}}
  
      {{#if this.recommendAutoPublish}}
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::AutoPublish
          @isMultiProfilePost={{@isMultiProfilePost}}
          @post={{@post}}
          @recommended={{this.recommendAutoPublish}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
          @socialProfile={{@socialProfile}}
        />
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::NotificationPublish
          @recommended={{this.recommendNotification}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
        />
      {{else}}
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::NotificationPublish
          @recommended={{this.recommendNotification}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
        />
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::AutoPublish
          @isMultiProfilePost={{@isMultiProfilePost}}
          @post={{@post}}
          @recommended={{this.recommendAutoPublish}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
          @socialProfile={{@socialProfile}}
        />
      {{/if}}
    </:body>
  </Shared::Post::Secondary::PublishingMethodSetup::Layout>
  */
  {
    "id": "nwK/JJJi",
    "block": "[[[8,[39,0],null,[[\"@title\"],[[28,[37,1],[\"onboarding.side_wiz.general.title\"],null]]],[[\"body\"],[[[[1,\"\\n    \"],[10,2],[12],[1,[30,0,[\"profileDescription\"]]],[13],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,0],[14,0,\"u--m__tb\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@onClick\",\"@variant\"],[[30,2],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,4],[\"arrow-left\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_words.back\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"recommendAutoPublish\"]],[[[1,\"      \"],[8,[39,5],null,[[\"@isMultiProfilePost\",\"@post\",\"@recommended\",\"@setPublishingSetupComponent\",\"@socialProfile\"],[[30,1],[30,3],[30,0,[\"recommendAutoPublish\"]],[30,4],[30,5]]],null],[1,\"\\n      \"],[8,[39,6],null,[[\"@recommended\",\"@setPublishingSetupComponent\"],[[30,0,[\"recommendNotification\"]],[30,4]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,6],null,[[\"@recommended\",\"@setPublishingSetupComponent\"],[[30,0,[\"recommendNotification\"]],[30,4]]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@isMultiProfilePost\",\"@post\",\"@recommended\",\"@setPublishingSetupComponent\",\"@socialProfile\"],[[30,1],[30,3],[30,0,[\"recommendAutoPublish\"]],[30,4],[30,5]]],null],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]]],[\"@isMultiProfilePost\",\"@back\",\"@post\",\"@setPublishingSetupComponent\",\"@socialProfile\"],false,[\"shared/post/secondary/publishing-method-setup/layout\",\"t\",\"if\",\"shared/ui/button\",\"svg-jar\",\"shared/post/secondary/publishing-method-setup/setup/auto-publish\",\"shared/post/secondary/publishing-method-setup/setup/notification-publish\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/no-publish-method/index.hbs",
    "isStrictMode": false
  });
  let NoPublishMethodComponent = _exports.default = (_class = class NoPublishMethodComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get socialProfile() {
      return this.args.socialProfile;
    }
    get profileDescription() {
      if (this.socialProfile.get('isBusiness')) {
        return this.intl.t('onboarding.side_wiz.general.subcopy.business_profile', {
          username: this.socialProfile.get('displayNickname')
        });
      }
      if (this.socialProfile.get('isCreator')) {
        return this.intl.t('onboarding.side_wiz.general.subcopy.creator_profile', {
          username: this.socialProfile.get('displayNickname')
        });
      }
      return this.intl.t('onboarding.side_wiz.general.subcopy.personal_profile', {
        username: this.socialProfile.get('displayNickname')
      });
    }
    get recommendAutoPublish() {
      return this.socialProfile.get('isInstagram') && this.socialProfile.get('isProfessional') || this.socialProfile.get('isTiktok');
    }
    get recommendNotification() {
      return !this.recommendAutoPublish;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NoPublishMethodComponent);
});